import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import axios from "axios";

export default function CheckInModal({ show, onHide, selected, refresh, API_BASE , token, branch}) {

  const [form, setForm] = useState({
    idProofType: "",
    idProofNumber: "",
    amountPaid: 0,
    paymentMode: "",
    branch
  });

  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleCheckIn = async () => {
    await axios.put(`${API_BASE}reservations/${selected._id}/checkin`, form,{
      headers: { Authorization: `Bearer ${token}` }
    });
    refresh();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Guest Check-In</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>ID Proof Type</Form.Label>
            <Form.Select name="idProofType" onChange={handleChange}>
              <option value="">Select</option>
              <option value="Aadhar">Aadhar</option>
              <option value="Passport">Passport</option>
              <option value="Driving License">Driving License</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>ID Proof Number</Form.Label>
            <Form.Control
              name="idProofNumber"
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Amount Paid</Form.Label>
            <Form.Control
              type="number"
              name="amountPaid"
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Payment Mode</Form.Label>
            <Form.Select name="paymentMode" onChange={handleChange}>
              <option value="">Select</option>
              <option value="Cash">Cash</option>
              <option value="UPI">UPI</option>
              <option value="Card">Card</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={handleCheckIn}>
          Complete Check-In
        </Button>
      </Modal.Footer>
    </Modal>
  );
}